import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";

const TOAST_OPTIONS = {
  style: {
    background: "#F9F6F0",
    border: "1px solid #E2D9CD",
    color: "#232321",
    fontFamily: "'Manrope', sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={TOAST_OPTIONS}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
